import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useI18n } from '../context/i18nContext';

const ProtectedRoute = ({ children }) => {
  // ============================================
  // HOOKS
  // ============================================
  const { isAuthenticated, loading } = useAuth();
  const { t } = useI18n();

  // ============================================
  // LOADING STATE
  // ============================================
  // Amíg a felhasználó adatai betöltödnek
  if (loading) {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <h1>{t('common.loading')}</h1>
          <div className="loading-spinner">
            <div className="spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  // ============================================
  // AUTHENTICATION CHECK
  // ============================================
  // Ha nincs bejelentkezet: átirányítás a login-hez
  if (!isAuthenticated) {
    // <Navigate to="/login" /> = React Router átirányítás
    // (nem page refresh, SPA navigáció)
    return <Navigate to="/login" replace />;
  }

  // ============================================
  // AUTHORIZED: Komponens megjelenítése
  // ============================================
  return children;
};

export default ProtectedRoute;